import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, Card, CardContent, Typography, Button, CircularProgress } from '@mui/material';

import meestLogo from '../../assets/logoNew.svg';

const paymentTypes = {
    C: 'Післяплата за відправлення',
    D: 'Послуги',
    T: 'Митні послуги',
    P: 'Пакування відправлення'
};

const MultiSession = () => {
    const { multiple_session_Id } = useParams();
    const navigate = useNavigate();

    const [id, setId] = useState(multiple_session_Id || '');
    const [data, setData] = useState(null || '');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [disabledButtons, setDisabledButtons] = useState({});

    const handleClick = (parcelNumber) => {
        setDisabledButtons(prev => ({ ...prev, [parcelNumber]: true }));

        redirectToSession(parcelNumber);

        setTimeout(() => {
            setDisabledButtons(prev => ({ ...prev, [parcelNumber]: false }));
        }, 10000);
    };

    useEffect(() => {
        handleSubmit();
    }, []);

    const handleSubmit = async () => {
        setLoading(true);
        setError(null);

        try {
            // get multi session
            const createResponse = await axios.get(
                `${process.env.REACT_APP_API_URL}/clients/v1/sessions/getter/multiple_session/?multiple_session_id=${id}&paymentSystemID=00000000-1111-1111-1111-000000000000`,
            );
            setData(createResponse.data.parcels);

        } catch (error) {
            if (error.response) {
            } else {
                setError('Сталася помилка мережі або сервера.');
            }
        } finally {
            setLoading(false);
        }
    };
    const redirectToSession = async (parcelNumber) => {
        try {
            // create session
            const createResponse = await axios.post(
                `${process.env.REACT_APP_API_URL}/clients/v1/sessions/payment/create`,
                { parcelNumber: parcelNumber, multisession_id: id, is_full: true }
            );

            if (createResponse.data?.payments.length > 1) {
                const redirectLink = `${process.env.REACT_APP_LINK_TO_SITE}/client/session/${createResponse.data.session_id}`;
                window.location.href = redirectLink;
                return;
            }
            if (createResponse.data?.payments.length === 1) {

                const redirectLink = createResponse.data?.payments[0].link_to_pay;
                window.location.href = redirectLink;
                return;
            }
            if (createResponse.data?.payments[0].service_to_pay === 'd50fcee4-2c4d-11ee-80bd-000c2961d091') {
                const redirectLink = `${process.env.REACT_APP_LINK_TO_SITE}/client/session/${createResponse.data.session_id}`;
                window.location.href = redirectLink;
                return;
            }


        } catch (error) {
            if (error.response) {
                const statusCode = error.response.status;
                let message = '';
                switch (statusCode) {
                    case 400:
                        message = 'Відправлення не знайдено. Перевірте номер.'; break;
                    case 409:
                        message = 'Відправлення наразі не потребує оплати.'; break;
                    case 503:
                        message = 'Виникли технічні проблеми. Спробуйте пізніше.'; break;
                    case 404:
                        message = 'Боргу за посилку не знайдено.'; break;
                    case 429:
                        message = 'Забагато спроб, спробуйте пізніше.'; break;
                }

                if (message) {
                    // redirect `/:parcelNumber`
                    navigate(`/${id}`, { state: { error: message } });

                }
            } else {
                setError('Сталася помилка мережі або сервера.');
            }
        } finally {
            setLoading(false);
        }
    };



    return (
        <Box height="100vh" bgcolor="#f5f5f5" display="flex" justifyContent="center" alignItems="center">
            <Box
                sx={{
                    width: '460px',
                    height: '150px',
                    backgroundColor: '#005096',
                    position: 'absolute',
                    top: 0,
                    display: {
                        xs: 'none',
                        sm: 'block',
                    },
                }}
            ></Box>
            <Card sx={{
                width: '420px',
                height: '94%',
                maxHeight: '100vh',
                borderRadius: '15px',
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                zIndex: '100'
            }}>
                <Box display="flex" justifyContent="center">
                    <img src={meestLogo} alt="Meest Logo" style={{ height: '40px', marginBottom: '10px' }} />
                </Box>
                <Typography variant="body1" display="flex" justifyContent="center" alignItems="center" >
                    Список відправлень до оплати
                </Typography>
                <Box flex="1" overflow="auto">
                    {data && data.map((item, index) => (
                        <Card key={index} sx={{ mb: 2, mt: 2 }}>
                            <CardContent>
                                <Box display="flex" alignItems="center" mb={1}>
                                    <Box ml={2}>
                                        <Typography variant="body1">
                                            Номер відправлення:
                                        </Typography>
                                        <Typography variant="h6" fontWeight={600}>{item.parcel_number}</Typography>
                                    </Box>
                                </Box>

                                {item.data.sort((a, b) => a.index - b.index).map(payment => (
                                    <Box key={payment.payment_number} mt={1}>
                                        <Box display="flex" justifyContent="space-between">
                                            <Typography variant="body2" color="textPrimary">
                                                {paymentTypes[payment.payment_type]}
                                            </Typography>
                                            <Typography variant="body2" color="textPrimary">
                                                {payment.amount ? `${payment.amount} ₴` : payment.amount}
                                            </Typography>
                                        </Box>
                                    </Box>
                                ))}
                                <Box display="flex" justifyContent="space-between" marginBottom={2}>
                                    <Typography variant="body1">Статус відправлення</Typography>
                                    <Typography>
                                        {item.parcel_status === 'success' ? 'Оплачено' : 'Очікуємо на оплату'}
                                    </Typography>
                                </Box>

                                {item.parcel_status !== 'success' && (
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        sx={{ backgroundColor: '#0061AF', fontWeight: 600 }}
                                        onClick={() => handleClick(item.parcel_number)}
                                        disabled={disabledButtons[item.parcel_number]}

                                    >
                                        Перейти до оплати
                                    </Button>
                                )}
                            </CardContent>
                        </Card>
                    ))}
                </Box>

            </Card >
        </Box >
    );
};

export default MultiSession;
